import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'leaflet/dist/leaflet.css';
import './i18n';
import { LoadScript } from '@react-google-maps/api';
import "mapbox-gl/dist/mapbox-gl.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LoadScript
      googleMapsApiKey="AIzaSyCuhI0kt8VzP7uNw_HHzHLsCaIq5L5Xv2U"
      libraries={['places']} 
    >
      <App />
    </LoadScript>
  </React.StrictMode>
);

reportWebVitals();